import React, {useState, useEffect} from 'react'
import { faEnvelope, faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';

const TopicItem = ({obj}) => {

    const [hover, setHover] = useState(false);

    function handleHover(state){
        setHover(state);
    };

    const styles = {
        item: {
            flex: 1,
            background: '#fff',
            minWidth: 260,
            marginBottom: 10,
            padding: 20,
            borderLeft: hover? '4px solid #006600': '4px solid #009900',
            borderRadius: 10
        },
        title:{
            color: hover? '#111': '#191919',
            fontSize: 20,
            fontWeight: 500,
            marginBottom: 5
        },
        description:{
            color: '#414141',
            fontSize: 14,
        },
        link:{
            textDecoration: 'none'
        }
    }

    return (
        <div style={styles.item} onMouseEnter={()=>handleHover(true)} onMouseLeave={()=>handleHover(false)}>
            <a href={`/topic/${obj.Slug}`} style={styles.link}>
                <h2 style={styles.title}>{obj.Title}</h2>
                <div style={styles.description}>{obj.Description}</div>
            </a>
        </div>
    )
}

export default TopicItem